import axios from 'axios'
import { useMemo } from 'react'
import useSWR from 'swr'
import browserEnv from '~/libs/env/browserEnv'

type MaintenanceData = {
  is_maintenance: boolean | undefined
  text?: string
}

export const useMaintenanceMode = (): MaintenanceData => {
  const { data: opsData } = useSWR<Record<string, { enabled: boolean; message?: string }>>(
    browserEnv.NEXT_PUBLIC_CLOUDFRONT_URL + '/app_config/ops.json',
    (url: string) => axios.get(url).then((res) => res.data),
  )

  const maintenanceData = useMemo(() => {
    if (opsData === undefined) {
      return { is_maintenance: undefined }
    }

    const maintenanceConfig = opsData?.enable_maintenance_mode_web

    if (!maintenanceConfig) {
      return { is_maintenance: false }
    }

    return {
      is_maintenance: maintenanceConfig.enabled,
      text: maintenanceConfig.message,
    }
  }, [opsData])

  return maintenanceData
}
